import tourbookPageLoad from './tourbookPageLoad';
import analyticsActions from './analyticsActions';

export default {
  ...analyticsActions,
  tourbookPageLoad,
};
